import React from 'react';
import classNames from 'classnames';

export default function FSTreeIcon({ className = '' }) {
	return <span className={classNames('icon icon-tree', className)} />;
}
